import {
  faBitbucket,
  faDeviantart,
  faDiscord,
  faFacebookSquare,
  faGit,
  faGithub,
  faGitlab,
  faInstagram,
  faLastfm,
  faLinkedin,
  faSoundcloud,
  faSpotify,
  faSteam,
  faTelegram,
  faThreads,
  faTiktok,
  faTwitch,
  faWhatsapp,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import {
  faEnvelope,
  faGlobeAsia,
  faLink,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

export const footerIcons = {
  telegram: faTelegram,
  github: faGithub,
  gitlab: faGitlab,
  git: faGit,
  bitbucket: faBitbucket,
  deviantart: faDeviantart,
  discord: faDiscord,
  facebook: faFacebookSquare,
  instagram: faInstagram,
  mail: faEnvelope,
  phone: faPhone,
  spotify: faSpotify,
  steam: faSteam,
  twitch: faTwitch,
  twitter: faXTwitter,
  tiktok: faTiktok,
  whatsapp: faWhatsapp,
  youtube: faYoutube,
  website: faGlobeAsia,
  link: faLink,
  linkedin: faLinkedin,
  soundcloud: faSoundcloud,
  lastfm: faLastfm,
  threads: faThreads,
};
